module.exports = __webpack_public_path__ + "img/upperCaseC.c584e30a.svg";